import { throwErrorMessage, throwInfo } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";
import {
    IS_LOADING,
    GET_EQUIPMENTSEPI,
    GET_COWORKERS_EQUIPMENTSEPI,
    GET_COMMON_AND_UNAFFECTED_EQUIPMENTS,
    SET_EPI_FILTERS,
    SET_CURRENT_EQUIPMENTEPI,
    SET_CURRENT_EQUIPMENTEPI_FORM,
    SET_CURRENT_EQUIPMENT_INPSECTION,
    SET_EQUIPMENTEPI_FORM_SECTIONS,
    SET_EQUIPMENTS_EPI_TAB_ID,
    MY_EQUIPMENTS_EPI,
    COWORKERS_EQUIPMENTS_EPI,
    SET_EQUIPMENTS_EPI_INDEX,
    SET_EPI_FILTERED_LIST,
    SET_NB_EPI_TO_CHECK,
    SET_EPICATEGORIES,
} from "./equipmentsEPIConstants";
import { adaptElementInspectionForMyOpen, adaptFormSectionForMyOpen } from "../humanResources/humanResourcesCast";

export function setEpiFiltersAction(filters, filtersInstance) {
    return {
        type: SET_EPI_FILTERS,
        filters: filters,
        filtersInstance,
    };
}

export function setEpiFilteredList(filteredEquipmentsEPI) {
    return {
        type: SET_EPI_FILTERED_LIST,
        filteredEquipmentsEPI: filteredEquipmentsEPI,
    };
}

export function setCurrentEquipmentEPIAction(equipmentEPI) {
    return {
        type: SET_CURRENT_EQUIPMENTEPI,
        currentEquipmentEPI: equipmentEPI,
    };
}

export function setCurrentEquipmentEPIForm(currentEquipmentEPIForm) {
    return {
        type: SET_CURRENT_EQUIPMENTEPI_FORM,
        currentEquipmentEPIForm: currentEquipmentEPIForm,
    };
}

export function setCurrentEquipmentInspectionAction(currentEquipmentInspection) {
    return {
        type: SET_CURRENT_EQUIPMENT_INPSECTION,
        currentEquipmentInspection,
    };
}

export function setEquipmentEPIFormSectionsAction(equipmentEPIFormSections) {
    return {
        type: SET_EQUIPMENTEPI_FORM_SECTIONS,
        equipmentEPIFormSections,
    };
}

export function epiIsLoading(value) {
    return {
        type: IS_LOADING,
        info: "Chargement...",
        isLoading: value,
    };
}

export function formsIsLoading(value, loadingType) {
    return {
        type: IS_LOADING,
        info: "equipmentEPIForm-" + loadingType,
        isLoading: value,
    };
}

export function equipmentsEPIIsLoading(value) {
    return {
        type: IS_LOADING,
        info: "Récupération des équipements/EPI",
        isLoading: value,
    };
}

export function nbEPIToCheckIsLoading(value) {
    return {
        type: IS_LOADING,
        info: "Récupération du nombre d'équipements/EPI à vérifier",
        isLoading: value,
    };
}

export function deletingEquipment(value) {
    return {
        type: IS_LOADING,
        info: "Suppression de l'équipement",
        isLoading: value,
    };
}

export function getMyEquipmentsEPIAction(equipmentsEPI) {
    return {
        type: GET_EQUIPMENTSEPI,
        equipmentsEPI: equipmentsEPI,
    };
}

export function getCoworkersEquipmentsEPIAction(equipmentsEPI) {
    return {
        type: GET_COWORKERS_EQUIPMENTSEPI,
        equipmentsEPI: equipmentsEPI,
    };
}

export function getCommonAndUnaffectedEquipmentsAction(commonAndUnaffectedEquipments) {
    return {
        type: GET_COMMON_AND_UNAFFECTED_EQUIPMENTS,
        commonAndUnaffectedEquipments: commonAndUnaffectedEquipments,
    };
}

export function setEquipmentsEPITabIdAction(tabId) {
    return {
        type: SET_EQUIPMENTS_EPI_TAB_ID,
        tabId,
    };
}

export function setEquipmentsEPIIndexAction(epiIndex) {
    return {
        type: SET_EQUIPMENTS_EPI_INDEX,
        epiIndex,
    };
}

function setNbEPIToCheckAction(nb) {
    return {
        type: SET_NB_EPI_TO_CHECK,
        nbEPIToCheck: nb,
    };
}

export function getEPICategoriesAction(epiCategories) {
    return {
        type: SET_EPICATEGORIES,
        epiCategories: epiCategories,
    };
}

export function getMyEquipmentsEPI(activeUser) {
    return (dispatch) => {
        var ids = [activeUser.emp_id];
        const headers = new Headers({ "Content-Type": "application/json" });
        dispatch(equipmentsEPIIsLoading(true));
        fetchWithTimeout("/api/v1/equipmentsEPI/get_employees_equipmentsEPI/", {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                userId: activeUser.id,
                ids,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((result) => {
                var equipmentsEPI = result[activeUser.emp_id];
                var myEquipmentsEPI = [];
                if (equipmentsEPI) {
                    if (equipmentsEPI.length > 0) {
                        myEquipmentsEPI = equipmentsEPI;
                        // .filter((e) =>
                        // {
                        //     return e["state"] !== "obsolete"
                        // });
                    }
                }
                dispatch(getMyEquipmentsEPIAction(myEquipmentsEPI));
                dispatch(equipmentsEPIIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur lors de la récupération de mes équipements/EPI ! - getMyEquipmentsEPI", err);

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération de mes équipements/EPI ! - getMyEquipmentsEPI",
                    })
                );
                dispatch(equipmentsEPIIsLoading(false));
            });
    };
}

export function getCoworkersEquipmentsEPI(activeUser, employeesOfCompany) {
    return (dispatch) => {
        var ids = employeesOfCompany.map((x) => x.id).filter((id) => id != activeUser.emp_id);
        const headers = new Headers({ "Content-Type": "application/json" });
        dispatch(equipmentsEPIIsLoading(true));
        fetchWithTimeout("/api/v1/equipmentsEPI/get_employees_equipmentsEPI/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                userId: activeUser.id,
                ids,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((result) => {
                var equipmentsEPI = [];
                var coWorkersequipmentsEPI = [];
                Object.entries(result).forEach(([key, value]) => {
                    if (value) {
                        equipmentsEPI = equipmentsEPI.concat(value);
                    }
                });
                if (equipmentsEPI.length > 0) {
                    coWorkersequipmentsEPI = equipmentsEPI;
                    // .filter((e) =>
                    // {
                    //     return e["state"] !== "obsolete"
                    // });
                }
                dispatch(getCoworkersEquipmentsEPIAction(coWorkersequipmentsEPI));
                dispatch(equipmentsEPIIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : epiActions - getCoworkersEquipmentsEPI", err);

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur : epiActions - getCoworkersEquipmentsEPI",
                    })
                );
                dispatch(equipmentsEPIIsLoading(false));
            });
    };
}

export function getCommonAndUnaffectedEquipments(activeUser, loggedEmployee) {
    return (dispatch) => {
        var ids = [loggedEmployee.company_id.id];
        const headers = new Headers({ "Content-Type": "application/json" });
        dispatch(equipmentsEPIIsLoading(true));
        fetchWithTimeout("/api/v1/equipmentsEPI/get_companies_equipmentsEPI/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                userId: activeUser.id,
                ids,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((result) => {
                let cuequipments = [];
                let filteredCuequipments = [];
                Object.entries(result).forEach(([key, value]) => {
                    if (value) {
                        Object.entries(value).forEach(([key, val]) => {
                            if ((val && val.equipment_id.agency_equipment) || !val.emp_id.id) {
                                cuequipments = cuequipments.concat(val);
                            }
                        });
                    }
                });
                if (cuequipments.length > 0) {
                    filteredCuequipments = cuequipments;
                    // .filter((e) =>
                    // {
                    //     return e["state"] !== "obsolete"
                    // });
                }
                dispatch(getCommonAndUnaffectedEquipmentsAction(filteredCuequipments));
                dispatch(equipmentsEPIIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : epiActions - getCommonAndUnaffectedEquipments", err);

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur : epiActions - getCommonAndUnaffectedEquipments",
                    })
                );
                dispatch(equipmentsEPIIsLoading(false));
            });
    };
}

export function selectEquipmentEPI(equipmentEPI, currentEquipmentEPIIndex) {
    return (dispatch) => {
        dispatch(setEquipmentsEPIIndexAction(currentEquipmentEPIIndex));
        dispatch(setCurrentEquipmentEPIAction(equipmentEPI));
    };
}

export function loadForm(equipmentInspection) {
    return (dispatch) => {
        dispatch(setCurrentEquipmentInspectionAction(equipmentInspection));
        let formSections = equipmentInspection.response.survey.pages.map((fs) => adaptFormSectionForMyOpen(fs));
        dispatch(setEquipmentEPIFormSectionsAction(formSections));
        dispatch(setCurrentEquipmentEPIForm(equipmentInspection.response));
    };
}

export function generateControlForm(equipment, activeUser, onSuccess) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        dispatch(formsIsLoading(true, "generateControlForm"));
        fetchWithTimeout("/api/v1/equipmentsEPI/generate_control_form/", {
            method: "POST",
            headers: headers,
            timeout: 60000,
            body: JSON.stringify({
                userId: activeUser.id,
                employeeEquipmentId: equipment.id,
            }),
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(async (result) => {
                let equipmentInspection = Object.values(result)[0];
                dispatch(loadForm(await adaptElementInspectionForMyOpen(equipmentInspection)));
                if (onSuccess && typeof onSuccess === "function") onSuccess();

                dispatch(formsIsLoading(false, "generateControlForm"));
            })
            .catch((err) => {
                console.error("Erreur : epiActions - generate_control_form", err);

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la génération du formulaire lié à l'équipement !",
                    })
                );

                dispatch(formsIsLoading(false, "generateControlForm"));
            });
    };
}

export function deleteEquipment(equipment_id, user, onSuccess) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        const body = {
            equipmentId: equipment_id,
            userId: user.id,
        };

        dispatch(deletingEquipment(true));

        fetchWithTimeout("/api/v1/equipmentsEPI/delete/", {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        })
            .then(function (response) {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                dispatch(
                    throwInfo({
                        title: "L'\équipement a été supprimé.",
                    })
                );
                if (onSuccess && typeof onSuccess === "function") onSuccess();
                dispatch(deletingEquipment(false));
            })
            .catch((err) => {
                console.error("Erreur : epiActions - deleteEquipment: " + err.message);
                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message: "Une erreur s'est produite lors de la suppression d'un équipement.",
                    })
                );

                dispatch(deletingEquipment(false));
            });
    };
}

export function saveEquipmentFields(equipment_id, fields, user, onSuccess) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        const body = {
            equipmentId: equipment_id,
            fields: fields,
            userId: user.id,
        };

        dispatch(epiIsLoading(true));

        fetchWithTimeout("/api/v1/equipmentsEPI/save/", {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        })
            .then(function (response) {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(() => {
                if (onSuccess && typeof onSuccess === "function") onSuccess();
                dispatch(epiIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : epiActions - saveEquipmentFields: " + err.message);
                dispatch(
                    throwErrorMessage({
                        title: "Erreur",
                        message: "Une erreur s'est produite lors de la sauvegarde des champs de l'équipement",
                    })
                );

                dispatch(epiIsLoading(false));
            });
    };
}

export function setEquipmentsEPITabId(tabId) {
    return (dispatch) => {
        dispatch(setEquipmentsEPITabIdAction(tabId));
    };
}

export function setEquipmentsEPIIndex(index) {
    return (dispatch) => {
        dispatch(setEquipmentsEPIIndexAction(index));
    };
}

export function getFiltersInstance(myEquipmentsEPI, coworkersEquipmentsEPI) {
    if (myEquipmentsEPI) {
        return MY_EQUIPMENTS_EPI;
    } else if (coworkersEquipmentsEPI) {
        return COWORKERS_EQUIPMENTS_EPI;
    }

    return null;
}

export function updateFilters(filters, myEquipmentsEPI, coworkersEquipmentsEPI) {
    return (dispatch) => {
        dispatch(setEpiFiltersAction(filters, getFiltersInstance(myEquipmentsEPI, coworkersEquipmentsEPI)));
    };
}

export function updateFilteredList(filteredList) {
    return (dispatch) => {
        dispatch(setEpiFilteredList(filteredList));
    };
}

export function actualizeNumberEPIToCheck(activeUser) {
    return (dispatch) => {
        dispatch(nbEPIToCheckIsLoading(true));
        const headers = new Headers({ "Content-Type": "application/json" });

        dispatch(setNbEPIToCheckAction(0));

        fetchWithTimeout("/api/v1/equipmentsEPI/get_nb_epi_to_check/" + activeUser.id + "/" + activeUser.emp_id, {
            method: "GET",
            headers: headers,
            timeout: 60000,
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((result) => {
                let nbEPIToCheck = 0;
                Object.entries(result).forEach(([key, value]) => {
                    if (value) {
                        nbEPIToCheck = nbEPIToCheck + value;
                    }
                });
                dispatch(setNbEPIToCheckAction(nbEPIToCheck));
                dispatch(nbEPIToCheckIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : epiActions - actualizeNumberEPIToCheck", err);
                dispatch(nbEPIToCheckIsLoading(false));
            });
    };
}

export function getEPICategories() {
    return (dispatch) => {
        dispatch(getEPICategoriesAction([]));

        const headers = new Headers({ "Content-Type": "application/json" });
        dispatch(epiIsLoading(true));
        fetchWithTimeout("/api/v1/equipmentsEPI/get_epi_categories/", {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then(async (result) => {
                var values = Object.values(result);
                dispatch(getEPICategoriesAction(values));
                dispatch(epiIsLoading(false));
            })
            .catch((err) => {
                console.error("Erreur : epiActions - getEPICategories", err);

                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des catégories EPI !",
                    })
                );

                dispatch(epiIsLoading(false));
            });
    };
}
